import * as methods from '@binance/react-bridge-methods';
import { create, createBrowserAdapter } from '@binance/bridge';

// eslint-disable-next-line import/no-cycle
import bridgeBrowser from './bridge.browser';

const bridge = typeof window === 'undefined' ? {
  ensureLogged: () => false,
  isLogged: () => false,
} : create(createBrowserAdapter({ ...methods, ...bridgeBrowser }));

export default bridge;
